import React, { useState, useRef } from 'react';
import { arrayOf, func, string } from 'prop-types';
import classNames from 'classnames';
import { Carousel } from '@fiverr-private/orca';
import Question from '../Question';
import { QuickQuestionViewType } from '../constants';
import { QUICK_QUESTIONS_VIEW_IS_SHOWN } from '../../../constants/biEvents';
import { useEffectOnce, useReporting } from '../../../hooks';
import CarouselNavigation from './CarouselNavigation';

import classes from './style.module.scss';

const QuickQuestionCarousel = ({
    className,
    currentSteps,
    onStepClick
}) => {
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(currentSteps.length > 1);
    const navigationRef = useRef();
    const { sendBiEvent, sendMixpanelEvent } = useReporting();

    useEffectOnce(() => {
        const params = {
            source: QuickQuestionViewType.Carousel
        };

        const event = {
            type: QUICK_QUESTIONS_VIEW_IS_SHOWN,
            params
        };

        sendBiEvent(event);
        sendMixpanelEvent(event);
    });

    const slides = currentSteps.map((step) => ({
        className: classes.carouselQuickQuestion,
        step,
        onStepClick
    }));

    const onScroll = ({ canScrollRight, canScrollLeft }) => {
        setCanScrollRight(canScrollRight);
        setCanScrollLeft(canScrollLeft);
    };

    const onScrollLeft = () => navigationRef.current.scrollLeft();

    const onScrollRight = () => navigationRef.current.scrollRight();

    return (
        <section className={classNames(classes.quickQuestionsCarousel, className)}
            data-testid="quick-questions-carousel">
            <Carousel slides={slides} Component={Question}
                scrollType={Carousel.SCROLL_TYPE.SINGLE}
                autoSlidesWidth
                onScroll={onScroll}
                navigationRef={navigationRef}
                hideDefaultArrows/>
            <CarouselNavigation canScrollLeft={canScrollLeft}
                canScrollRight={canScrollRight}
                onScrollLeft={onScrollLeft}
                onScrollRight={onScrollRight}/>
        </section>
    );
};

QuickQuestionCarousel.propTypes = {
    className: string,
    currentSteps: arrayOf(string).isRequired,
    onStepClick: func
};

export default QuickQuestionCarousel;
